import { NotificationMessageType, websocket } from '@playcastdotio/Messaging';
import { sendMessage } from './realtimeMessaging';
import { isMobileDevice } from '../../utility/utility';
import { getPersistentPlayerId } from '../../api';
import { authStore } from '../../api/stores/globalStores';
import { sendAnalytics, PlaycastAnalyticsHostProspectEmailed, PlaycastAnalyticsQuickstartWishlistEmailed } from '@playcastdotio/Analytics';

export const notifyMobileInstallReminder = (isNewAccount = false, email?: string) => {
  // Only send notification if user is on mobile device AND it's a new account
  if (!isMobileDevice()) {
    return;
  }

  if (!isNewAccount) {
    return;
  }

  // Make sure the email is valid before sending the event
  if (email) {
    sendAnalytics({
      name: 'Host Prospect Emailed',
      role: 'host',
      persistentId: getPersistentPlayerId(),
      hostAuthId: authStore.currentState.playerAuthId,
      email,
    } as PlaycastAnalyticsHostProspectEmailed);
  }

  const outboundMessage = websocket.generators.notification(NotificationMessageType.NOTIFICATION_MOBILE_USER_INSTALL, {});
  sendMessage(outboundMessage);
};

export const notifyWishlistDeadDrop = (email?: string, persistentId?: string, hostAuthId?: string, campaignId?: string) => {
  // Make sure the email, persistentId, and hostAuthId are valid before sending the event
  if (email && persistentId && hostAuthId) {
    sendAnalytics({
      name: 'Wishlist Emailed',
      role: 'player',
      flow: 'quickstart',
      persistentId,
      playerAuthId: hostAuthId, // User is authenticated at this point
      hostAuthId,
      email,
    } as PlaycastAnalyticsQuickstartWishlistEmailed);
  }

  // Get JWT token from authStore to pass in message payload (avoiding AUTH_UPGRADE lag)
  const tokenJwt = authStore.currentState.accessToken;

  const outboundMessage = websocket.generators.notification(NotificationMessageType.NOTIFICATION_WISHLIST_DEADDROP, { 
    campaignId,
    tokenJwt, // Pass JWT in payload for backend to authenticate user
  });
  sendMessage(outboundMessage);
}; 